// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__5A01H","line":"default_line__1okDC"};